import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import MidwestContent from "./MidwestMixerContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/midwest/mixers" component={MidwestContent} />
          <Route path="/suppliers/midwest">
            <Redirect to="/suppliers/midwest/mixers" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
